import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { DashboardCaseStudy } from './pages/DashboardCaseStudy';
import { VerizonCaseStudy } from './pages/VerizonCaseStudy';
import { ScrollToTop } from './components/ScrollToTop';
import { PageTransition } from './components/PageTransition';
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-0">
      <Routes location={location} key={location.pathname} data-id="element-1">
        <Route path="/" element={<PageTransition data-id="element-3">
              <HomePage data-id="element-4" />
            </PageTransition>} data-id="element-2" />
        <Route path="/aboutme" element={<PageTransition data-id="element-6">
              <AboutPage data-id="element-7" />
            </PageTransition>} data-id="element-5" />
        <Route path="/dashboard" element={<PageTransition data-id="element-9">
              <DashboardCaseStudy data-id="element-10" />
            </PageTransition>} data-id="element-8" />
        <Route path="/verizon" element={<PageTransition data-id="element-12">
              <VerizonCaseStudy data-id="element-13" />
            </PageTransition>} data-id="element-11" />
      </Routes>
    </AnimatePresence>;
}
export function App() {
  return <BrowserRouter data-id="element-14">
      <ScrollToTop data-id="element-15" />
      <AnimatedRoutes data-id="element-16" />
    </BrowserRouter>;
}